import script from "./LastPulse.vue?vue&type=script&lang=ts&setup=true"
export * from "./LastPulse.vue?vue&type=script&lang=ts&setup=true"

import "./LastPulse.vue?vue&type=style&index=0&id=2496e209&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2496e209"]])

export default __exports__